export const cleanup = Symbol("cleanup");
export const hideable = Symbol("hideable");
